import * as util from '../typings/util';
import qs from 'query-string';

/**
 * 解析url，返回组成部分
 *
 * @method parseUrl
 * @param {String} url 待解析的url
 * @return {Object|null} 解析成功返回URL组成部分，参考window.location。解析失败返回null
 * @example
 * parseUrl('http://www.qq.com:80/?name=value#hash')
 * 返回
 * {
	 *     hash: "#hash",
	 *     host: "www.qq.com",
	 *     hostname: "www.qq.com",
	 *     href: "http://www.qq.com/?name=value#hash",
	 *     pathname: "/",
	 *     port: "80",
	 *     protocol: "http:",
	 *     search: "?name=value"
	 * };
 */
export function parseUrl(url: string): util.TParsedUrl | null {
  if (/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/.test(url)) {
    const host = RegExp.$4.split(':');
    return {
      protocol: RegExp.$1,
      host: RegExp.$4,
      hostname: host[0],
      port: host[1] || '',
      pathname: RegExp.$5,
      search: RegExp.$6,
      hash: RegExp.$8,
      href: url,
    };
  }
  return null;
}


/**
 * 将query string解析为object
 *
 * @method parseQueryString
 * @param {String} queryString 待解析的查询字符串
 * @param options
 * @return {Object} 解析结果
 * @example
 * parseQueryString('name=value&hash[a]=A&hash[b]=B') : {
 *     "name": "value",
 *     "hash": {
 *         "a": "A",
 *         "b": "B"
 *     }
 * };
 */
export function parseQueryString(queryString: string, options?: qs.ParseOptions): qs.ParsedQuery {
  return qs.parse(queryString, options);
}

/**
 * 将object解析为query string
 * @param obj
 * @param traditional
 * @returns {string}
 */
// eslint-disable-next-line
export function jsonToQueryString(obj: any): string {
  return qs.stringify(obj);
}


/**
 * 给URL添加/替换多个参数，例如在url后面添加/替换_wv=1027
 *
 * @param url {string}
 * @param params {object}
 *
 * @return {string}
 */
// eslint-disable-next-line
export function appendParams(url: string, params: any): string {
  return qs.stringifyUrl({
    url,
    query: params,
  });
}

/**
 * 给URL添加/替换多个参数，例如在url后面添加/替换_wv=1027, 并清理deletedParams 中包含的参数
 * @param url
 * @param options
 * @returns {string|*}
 */
// eslint-disable-next-line
// export function modifyParams(url, appendParams, deletedParams) {
//   // TODO
//   return url;
// }

export function getUrlQuery(url: string, options?: qs.ParseOptions): qs.ParsedQuery<string> {
  return qs.parseUrl(url, options).query;
}
